module.exports = __webpack_public_path__ + "static/img/mv-sp.efd2d5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mv-sp.png
// module id = g1Yz
// module chunks = 0